import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/**
 * Action types & creators
 */
const { Types, Creators } = createActions({
  resetTransactions: [],
  loadTransaction: ['partner', 'transaction'],
  loadTransactions: ['partner', 'params'],
  loadMoreTransactions: ['partner', 'params'],
  loadTransactionsSuccess: ['data'],
  loadMoreTransactionsSuccess: ['data'],
  cancelTransaction: ['partner', 'order'],
  cancelTransactionSuccess: ['data'],
  exportTransactions: ['partner', 'params'],
  exportTransactionsSuccess: []
});

export { Types };

export default Creators;

/**
 * Handlers
 */
const INITIAL_STATE = Immutable({
  loading: true,
  loadingMore: false,
  exporting: false,
  transaction: '',
  data: {}
});

const resetTransactions = () => INITIAL_STATE;

const loadTransactions = () => INITIAL_STATE;

const loadMoreTransactions = (state, action) => ({
  ...state,
  loadingMore: true
});

const loadMoreTransactionsSuccess = (state, action) => ({
  ...state,
  loadingMore: false,
  data: {
    ...state.data,
    total: action.data.total,
    remaining: action.data.remaining,
    entries: [...state.data.entries, ...action.data.entries]
  }
});

const loadTransaction = (state, action) => ({
  ...INITIAL_STATE,
  transaction: action.transaction
});

const loadTransactionsSuccess = (state, action) => ({
  ...state,
  loading: false,
  data: action.data
});

const cancelTransactionSuccess = (state, action) => ({
  ...state,
  data: {
    ...state.data,
    status: action.data.status
  }
});

const exportTransactions = (state, action) => ({
  ...state,
  exporting: true
});

const exportTransactionsSuccess = (state, action) => ({
  ...state,
  exporting: false
});

/**
 * Reducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_TRANSACTIONS]: resetTransactions,
  [Types.LOAD_TRANSACTION]: loadTransaction,
  [Types.LOAD_TRANSACTIONS]: loadTransactions,
  [Types.LOAD_TRANSACTIONS_SUCCESS]: loadTransactionsSuccess,
  [Types.LOAD_MORE_TRANSACTIONS]: loadMoreTransactions,
  [Types.LOAD_MORE_TRANSACTIONS_SUCCESS]: loadMoreTransactionsSuccess,
  [Types.CANCEL_TRANSACTION_SUCCESS]: cancelTransactionSuccess,
  [Types.EXPORT_TRANSACTIONS]: exportTransactions,
  [Types.EXPORT_TRANSACTIONS_SUCCESS]: exportTransactionsSuccess
});
